import { Box, Heading, Link, Text } from '@chakra-ui/react'

import { useInterview } from '@/react-query/interview/interview'
import Card from '@/views/components/Card/Card'
import { EditCandidate } from '@/views/screens/Interview/components/CandidateCard/EditCandidate/EditCandidate'

import { CreateCandidate } from './CreateCandidate/CreateCandidate'
import { AtsMatchBadge } from './AtsMatchBadge'

export const CandidateCard = () => {
  const { data: interview } = useInterview()
  const candidateId = interview?.candidateId
  const interviewType = interview?.type
  const atsProfileUrl = interview?.Candidate?.atsProfileUrl

  return (
    <Card className="flex flex-col px-[2.5rem] py-[1.8rem] w-full relative">
      <>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <Heading size={'sm'}>
              {interviewType === 'INTAKE' ? 'Hiring manager' : 'Candidate'}
            </Heading>
            <AtsMatchBadge />
          </Box>
          {atsProfileUrl && (
            <Link
              href={atsProfileUrl}
              isExternal
              fontSize="xs"
              color="blue.500"
              display="flex"
              alignItems="center"
              gap={1}
              _hover={{ textDecoration: 'underline' }}
            >
              <Text as="span" aria-hidden>
                🔗
              </Text>
              View in ATS
            </Link>
          )}
        </Box>
        {candidateId ? <EditCandidate /> : <CreateCandidate />}
      </>
    </Card>
  )
}
